(function () {
  const drawer = document.querySelector("[data-collection-filters-drawer]");
  const backdrop = document.querySelector("[data-collection-filters-backdrop]");
  const toggleButtons = document.querySelectorAll(
    "[data-collection-filters-toggle]",
  );
  const closeButtons = document.querySelectorAll(
    "[data-collection-filters-close]",
  );
  const applyButton = document.querySelector("[data-collection-filters-apply]");
  const resetButton = document.querySelector("[data-collection-filters-reset]");
  const accordionToggles = document.querySelectorAll(
    "[data-filter-accordion-toggle]",
  );
  if (!drawer) return;

  const collectionUrl = drawer.getAttribute("data-collection-url") || "";
  let isOpen = false;

  function getFocusableElements(container) {
    return container.querySelectorAll(
      'button:not([disabled]), a[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])',
    );
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;

    drawer.classList.remove("translate-x-full");
    drawer.classList.add("translate-x-0");
    backdrop.classList.remove("opacity-0", "pointer-events-none");
    backdrop.classList.add("opacity-100", "pointer-events-auto");

    document.body.classList.add("overflow-hidden");

    toggleButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "true");
    });

    requestAnimationFrame(() => {
      const focusable = getFocusableElements(drawer);
      if (focusable.length > 0) {
        focusable[0].focus();
      }
    });

    document.addEventListener("keydown", handleKeydown);
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;

    drawer.classList.remove("translate-x-0");
    drawer.classList.add("translate-x-full");
    backdrop.classList.remove("opacity-100", "pointer-events-auto");
    backdrop.classList.add("opacity-0", "pointer-events-none");

    document.body.classList.remove("overflow-hidden");

    toggleButtons.forEach((btn) => {
      btn.setAttribute("aria-expanded", "false");
    });

    const lastTrigger = document.querySelector(
      "[data-collection-filters-toggle]",
    );
    if (lastTrigger) {
      lastTrigger.focus();
    }

    document.removeEventListener("keydown", handleKeydown);
  }

  function handleKeydown(e) {
    if (e.key === "Escape") {
      closeDrawer();
    }

    if (e.key === "Tab") {
      const focusable = getFocusableElements(drawer);
      if (focusable.length === 0) return;

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  function toggleAccordion(toggle) {
    const contentId = toggle.getAttribute("aria-controls");
    const content = document.getElementById(contentId);
    const icon = toggle.querySelector("[data-filter-accordion-icon]");

    if (!content) return;

    const isExpanded = toggle.getAttribute("aria-expanded") === "true";

    toggle.setAttribute("aria-expanded", String(!isExpanded));

    if (isExpanded) {
      content.classList.add("hidden");
      if (icon) {
        icon.classList.remove("-rotate-90");
        icon.classList.add("rotate-90");
      }
    } else {
      content.classList.remove("hidden");
      if (icon) {
        icon.classList.remove("rotate-90");
        icon.classList.add("-rotate-90");
      }
    }
  }

  function applyFilters() {
    const url = new URL(collectionUrl, window.location.origin);

    const checkboxes = drawer.querySelectorAll(
      'input[type="checkbox"][data-filter-checkbox]',
    );
    checkboxes.forEach((checkbox) => {
      if (checkbox.checked) {
        url.searchParams.append(checkbox.name, checkbox.value);
      }
    });

    const priceInputs = drawer.querySelectorAll("[data-price-filter-input]");
    priceInputs.forEach((input) => {
      const val = input.value.trim();
      if (val !== "") {
        url.searchParams.append(input.name, val);
      }
    });

    const selectedSort = drawer.querySelector('input[name="sort_by"]:checked');
    if (selectedSort) {
      url.searchParams.set("sort_by", selectedSort.value);
    }

    window.location.href = url.toString();
  }

  function resetFilters() {
    window.location.href = collectionUrl;
  }

  toggleButtons.forEach((btn) => {
    btn.addEventListener("click", openDrawer);
  });

  closeButtons.forEach((btn) => {
    btn.addEventListener("click", closeDrawer);
  });

  if (backdrop) {
    backdrop.addEventListener("click", closeDrawer);
  }

  accordionToggles.forEach((toggle) => {
    toggle.addEventListener("click", () => {
      toggleAccordion(toggle);
    });
  });

  if (applyButton) {
    applyButton.addEventListener("click", applyFilters);
  }

  if (resetButton) {
    resetButton.addEventListener("click", resetFilters);
  }
})();
